"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _styleModifiers = require("../../../utils/styleModifiers");

var _useNav = require("../hooks/useNav");

var _constants = require("../constants");

var _TextWrapper = _interopRequireDefault(require("./TextWrapper"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubItemsWrapper = _styledComponents.default.ul.withConfig({
  displayName: "SubItemsWrapper",
  componentId: "gcexl6-0"
})(["background-color:", ";margin:0;padding:0;", "{padding-left:", ";text-align:left;}", ""], (0, _toColorString.default)(_constants.BG_COLOR), _TextWrapper.default, (0, _rem.default)(_spacing.default.base * 6), (0, _styleModifiers.when)('navVariant', _useNav.NAV_EXPANDED_STATES.COLLAPSED_X, (0, _styledComponents.css)(["border-radius:0px 2px 2px 2px;box-shadow:0 1px 4px rgba(37,38,46,0.4);left:", ";position:absolute;top:0;width:", ";z-index:10;", "{font-size:", ";padding-left:", ";}"], (0, _rem.default)(_constants.LEFT_NAV_CLOSED_WIDTH_PX), (0, _rem.default)(_constants.LEFT_NAV_OPEN_WIDTH_PX), _TextWrapper.default, (0, _rem.default)(_typography.default.size.scale[0]), (0, _rem.default)(_spacing.default.base))));

var _default = SubItemsWrapper;
exports.default = _default;